import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { formatNumber } from "../../../../../../common/utils";
import { EmissionsChainTransportResultsDTO } from "../../../../../../datasources/api-client/data-contracts";

export const rows = (data: EmissionsChainTransportResultsDTO) => {
	const total = data.total.co2Wtw.value;

	return Object.entries(data)
		.filter(([key]) => key !== "total")
		.map(([key, { co2Wtw }], index) => ({
			id: index,
			category: key,
			co2Wtw: {
				value: co2Wtw.value,
				percent: total !== 0 ? (co2Wtw.value / total) * 100 : 0,
			},
		}));
};

const getRowName = (name: string) => {
	switch (name) {
		case "trips":
			return "Haulage";
		case "hubs":
			return "Hub";
		default:
			return "";
	}
};

export const dataCol: GridColDef[] = [
	{
		field: "category",
		headerName: "type of transport",
		flex: 1,
		sortable: false,
		renderCell: (params) => (
			<Stack height={"100%"} justifyContent={"center"}>
				<Typography variant="body1">{getRowName(params.value)}</Typography>
			</Stack>
		),
	},
	{
		field: "co2Wtw",
		headerName: "emissions",
		flex: 1,
		sortable: false,
		renderCell: (params) => (
			<Stack spacing={1} height={"100%"} direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
				<Typography variant="body1">{formatNumber(params.value.value, "decimal", 2, 2)}</Typography>
				<Typography variant="caption" color="text.secondary">
					({formatNumber(params.value.percent / 100, "percent", 2, 2)})
				</Typography>
			</Stack>
		),
	},
];
